import React, { Fragment, useState, useEffect } from 'react';
import { ThemeProvider } from '@emotion/react';
import { BlankPage } from '@packages/fdpq-common';
import { getQueryParamsFromUrl } from '@packages/fdpq-core/utils/url';
import { widgetSize as WIDGET_SIZE } from '@packages/fdpq-common/constants/ui';
import FdpqWidget from './FdpqWidget';
import { getInitialState } from '../utils/VehicleUtil';

const queryParams = getQueryParamsFromUrl();
const shouldRenderWidget = (params) => {
  if (typeof window === 'undefined') {
    return false;
  }
  if (params) {
    return false;
  }
  return true;
};

const getWidgetSize = (width) => {
  if (width < 654) {
    return WIDGET_SIZE.SMALL;
  }
  if (width < 948) {
    return WIDGET_SIZE.MEDIUM;
  }
  return WIDGET_SIZE.LARGE;
};

const FdpqWidgetWrapper = ({ initialData, initialWidgetSize, texts }) => {
  const [state, setState] = useState({
    initialData,
    shouldRenderWidget: shouldRenderWidget(queryParams),
    texts,
  });

  if (typeof window !== 'undefined') initialWidgetSize = getWidgetSize(window.innerWidth);

  useEffect(() => {
    if (typeof window !== 'undefined' && !shouldRenderWidget(queryParams)) {
      (async () => {
        if (queryParams && queryParams.apikey) {
          const initialState = await getInitialState({ initialData, queryParams, texts });
          setState(initialState);
          window.fdpqWidget = { initialData: initialState.initialData }; // This is for debugging purpose
        }
      })();
    }
  }, []);
  return (
    <Fragment>

      {(state.shouldRenderWidget ? (
        <FdpqWidget initialData={state.initialData} initialWidgetSize={initialWidgetSize} />
      ) : (
        <ThemeProvider theme={initialData.theme}>
          <BlankPage initialWidgetSize={initialWidgetSize} hasError={state.hasError} texts={state.texts} />
        </ThemeProvider>
      ))}
    </Fragment>
  );
};

export default FdpqWidgetWrapper;
